$(document).ready(function () {
  $(".side_menu_btn").on("click", function () {
    $(this).toggleClass("active");
    $(".side_menu4_overlay").toggleClass("show");
    $(".side_menu4_overlay2").toggleClass("show");
    $(".side_menu_style4").toggleClass("show");
  });

  $(".side_menu_style4 .clss").on("click", function () {
    $(".side_menu4_overlay").toggleClass("show");
    $(".side_menu4_overlay2").toggleClass("show");
    $(".side_menu_style4").toggleClass("show");
  });
});
$(function () {
  gsap.registerPlugin(ScrollTrigger, TextPlugin, MotionPathPlugin);
  const isMobile =
    /iPhone|iPad|iPod|Android/i.test(navigator.userAgent) ||
    window.innerWidth <= 768;

  if (!isMobile) {
    const scrollbar = Scrollbar.init(
      document.querySelector("#scroll-container"),
      {
        damping: 0.1,
        thumbMinSize: 20,
        renderByPixels: true,
        alwaysShowTracks: false,
        continuousScrolling: true,
      }
    );
    ScrollTrigger.scrollerProxy("#scroll-container", {
      scrollTop(value) {
        if (arguments.length) {
          scrollbar.scrollTop = value;
        }
        return scrollbar.scrollTop;
      },
      getBoundingClientRect() {
        return {
          top: 0,
          left: 0,
          width: window.innerWidth,
          height: window.innerHeight,
        };
      },
      pinType: document.querySelector("#scroll-container").style.transform
        ? "transform"
        : "fixed",
    });

    scrollbar.addListener(ScrollTrigger.update);

    gsap.to(".bg", {
      backgroundPosition: "50% 100%",
      ease: "none",
      scrollTrigger: {
        trigger: ".bg",
        scroller: "#scroll-container",
        start: "top bottom",
        end: "bottom top",
        scrub: 1,
      },
    });
    gsap.to(".zoom-imgs", {
      scale: 1.1,
      duration: 0.3,
      ease: "power2.out",
      paused: true,
    });
    document.querySelectorAll(".zoom-imgs").forEach((item) => {
      item.addEventListener("mouseenter", function () {
        gsap.to(this, {
          scale: 1.1,
          duration: 5,
          ease: "power2.out",
        });
      });

      item.addEventListener("mouseleave", function () {
        gsap.to(this, {
          scale: 1,
          duration: 5,
          ease: "power2.out",
        });
      });
    });
  }
  const contents = document.querySelectorAll(".content-ani");
  gsap.fromTo(
    contents,
    {
      text: {
        value: "Lorem ipsum dolor sit amet consectetur ",
        padSpace: true,
      },
    },
    {
      text: {
        value:
          " Lorem ipsum dolor sit amet consectetur. Leo neque in sed posuere eu. Arcu nibh vestibulum tristique gravida. Sit eget malesuada amet sociis ut ut pellentesque sed. Sit eget in eget semper.",
        padSpace: true,
      },
      duration: 1,
      scrollTrigger: {
        trigger: contents,
        scroller: "#scroll-container",
        start: "top 80%",
        end: "bottom 20%",
        toggleActions: "play none none none",
      },
      ease: "none",
    }
  );

  const image = document.querySelectorAll(".img-ani");
  const image2 = document.querySelectorAll(".img-ani2");
  if (!isMobile) {
    image.forEach((image) => {
      gsap.fromTo(
        image,
        {
          opacity: 0,
          y: 50,
        },
        {
          opacity: 1,
          y: 0,
          duration: 1,
          scrollTrigger: {
            trigger: image,
            scroller: "#scroll-container",
            start: "top 80%",
            end: "bottom 20%",
            toggleActions: "play none none none",
          },
        }
      );
      const imageAbout = document.querySelector(".image-about");
      const bgs = document.querySelector(".bgs");
      gsap.to(bgs, {
        TransitionEvent: "100",
        ease: "none",
        scrollTrigger: {
          trigger: imageAbout,
          scroller: "#scroll-container",
          start: "top 80%",
          end: "bottom 20%",
          scrub: true,
        },
      });
    });
    image2.forEach((image2) => {
      gsap.fromTo(
        image2,
        {
          opacity: 0,
          y: 50,
        },
        {
          opacity: 1,
          y: 0,
          duration: 1,
          scrollTrigger: {
            trigger: image2,
            scroller: "#scroll-container",
            start: "top 95%",
            end: "bottom 20%",
            toggleActions: "play none none none",
          },
        }
      );
    });
  }
  if (!isMobile) {
    const titleinfo = document.querySelectorAll(".title-info");
    titleinfo.forEach((titleinfo) => {
      gsap.fromTo(
        titleinfo,
        {
          opacity: 0,
          y: 50,
        },
        {
          opacity: 1,
          y: 0,
          duration: 0.5,
          scrollTrigger: {
            trigger: titleinfo,
            scroller: "#scroll-container",
            start: "top 90%",
            end: "bottom 20%",
            toggleActions: "play none none none",
          },
        }
      );
    });
  }
  const titleprin = document.querySelectorAll(".title-prin");
  if (!isMobile) {
    titleprin.forEach((titleprin) => {
      gsap.fromTo(
        titleprin,
        {
          opacity: 0,
          y: 50,
        },
        {
          opacity: 1,
          y: 0,
          duration: 1,
          scrollTrigger: {
            trigger: titleprin,
            scroller: "#scroll-container",
            start: "top 90%",
            end: "bottom 20%",
            toggleActions: "play none none none",
          },
        }
      );
    });
  }
});

$(function () {
  const svg = document.getElementById("svg");
  const tl = gsap.timeline();
  const curve = "M0 502S175 272 500 272s500 230 500 230V0H0Z";
  const flat = "M0 2S175 1 500 1s500 1 500 1V0H0Z";

  tl.to(
    ".loader-wrap-heading .load-text , .loader-wrap-heading .cont , .loader-wrap-heading .logo",
    {
      delay: 1.5,
      y: -100,
      opacity: 0,
    }
  ).call(() => {
    const navItems = document.querySelectorAll(".nav-item");

    navItems.forEach((navItem) => {
      const observer = new IntersectionObserver(
        (entries) => {
          if (entries[0].isIntersecting) {
            gsap.from(navItem, {
              duration: 1.5,
              y: -100,
              opacity: 0,
              ease: "power2.inOut",
            });

            const navLinks = navItem.querySelectorAll("ul li");
            gsap.from(navLinks, {
              duration: 1.5,
              y: -50,
              opacity: 0,
              stagger: 0.1,
              ease: "power2.inOut",
            });

            observer.unobserve(navItem);
          }
        },
        { threshold: 0.5 }
      );

      observer.observe(navItem);
    });
    gsap.from(".image-he-3 img", {
      duration: 2,
      y: "100%",
      ease: "power2.inOut",
    });
    gsap.from(".image-he-2 img", {
      duration: 2,
      y: "100%",
      ease: "power2.inOut",
    });
    gsap.from(".line", {
      duration: 1.5,
      scaleX: 0,
      ease: "power2.inOut",
      delay: 1.5,
    });
    gsap.from(".line2", {
      duration: 1.5,
      scaleX: 0,
      ease: "power2.inOut",
      delay: 2,
    });
    const titleinfo = document.querySelectorAll(".title-infox");
    titleinfo.forEach((titleinfo) => {
      gsap.fromTo(
        titleinfo,
        {
          opacity: 0,
          y: -50,
        },
        {
          opacity: 1,
          y: 0,
          duration: 2.5,
          scrollTrigger: {
            trigger: titleinfo,
            toggleActions: "play none none none",
          },
        }
      );
    });
  });
  tl.to(svg, {
    duration: 0.5,
    attr: { d: curve },
    ease: "power2.easeIn",
  }).to(svg, {
    duration: 0.5,
    attr: { d: flat },
    ease: "power2.easeOut",
  });
  tl.to(".loader-wrap", {
    y: -1500,
  });
  tl.to(".loader-wrap", {
    zIndex: -1,
    display: "none",
  });
});

document.addEventListener("DOMContentLoaded", function () {
  const img1 = document.querySelector(".img-1");
  const img2 = document.querySelector(".img-2");
  const path1 = [
    { x: 0, y: -200 },
    { x: 0, y: 90 },
  ];
  const path2 = [
    { x: -100, y: 0 },
    { x: 100, y: 0 },
  ];
  rotateImage(img1, path1);
  rotateImage(img2, path2);
});

function rotateImage(image, path) {
  gsap.to(image, {
    duration: 2,
    motionPath: {
      path: path,
      autoRotate: false,
    },
    repeat: -1,
    ease: "power2.inOut",
  });
}

const tabs = document.querySelectorAll(".tab");
const tabContents = document.querySelectorAll(".tab-content");

tabs.forEach((tab) => {
  tab.addEventListener("click", () => {
    tabs.forEach((t) => t.classList.remove("active"));
    tab.classList.add("active");

    const tabId = tab.getAttribute("data-tab");

    tabContents.forEach((content) => {
      gsap.to(content, {
        duration: 0.5,
        opacity: 0,
        display: "none",
        onComplete: () => {
          document.getElementById(tabId).style.display = "block";
          gsap.to(document.getElementById(tabId), {
            duration: 0.2,
            opacity: 1,
          });
        },
      });
    });
  });
});
document.getElementById('search-btn').addEventListener('click', function(event) {
  event.preventDefault();
  var searchContainer = document.getElementById('search-container');
  if (searchContainer.style.display === 'none' || searchContainer.style.display === '') {
      searchContainer.style.display = 'inline-block'; 
      setTimeout(function() {
          searchContainer.classList.add('active'); 
      }, 10);
  } else {
      searchContainer.classList.remove('active'); 
      setTimeout(function() {
          searchContainer.style.display = 'none';
      }, 300);å
  }
});


$('.action--menu').on('click', function() {
})